"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TrustBox = void 0;

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _icons = require("../../../icons");

var _EmblemFrame = _interopRequireDefault(require("../../molecules/EmblemFrame"));

var _Flex = _interopRequireDefault(require("../../atoms/Flex"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      position: 'relative',
      marginTop: theme.spacing(5)
    },
    trustCard: {
      height: '100%',
      padding: theme.spacing(4),
      borderStyle: 'solid',
      borderWidth: 2
    },
    // avatar1: {
    //   height: theme.spacing(8),
    //   width: theme.spacing(8),
    //   position: 'absolute',
    //   left: `calc(50% - ${theme.spacing(4)}px)`,
    //   top: -theme.spacing(4),
    //   backgroundColor: theme.palette.background.paper,
    //   borderColor: theme.palette.secondary.main,
    //   borderWidth: 2,
    //   borderStyle: 'solid'
    // },
    // avatar2: {
    //   height: theme.spacing(6),
    //   width: theme.spacing(6),
    //   position: 'absolute',
    //   left: `calc(50% - ${theme.spacing(11)}px)`,
    //   top: -theme.spacing(3)
    // },
    // avatar3: {
    //   height: theme.spacing(6),
    //   width: theme.spacing(6),
    //   position: 'absolute',
    //   left: `calc(50% + ${theme.spacing(5)}px)`,
    //   top: -theme.spacing(3)
    // },
    avatarIcon: {
      width: theme.spacing(8),
      height: theme.spacing(8),
      fill: theme.palette.primary.main
    },
    title: {
      marginTop: theme.spacing(2),
      textDecoration: 'underline'
    },
    icon: {
      marginRight: theme.spacing(2)
    },
    textContainer: {
      marginTop: theme.spacing(2)
    }
  };
});

var Row = function Row(_ref) {
  var children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Flex.default, {
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_CheckCircle.default, {
    className: classes.icon
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h5"
  }, children));
};

var TrustBox = function TrustBox(_ref2) {
  var className = _ref2.className,
      trustPoints = _ref2.trustPoints,
      props = _objectWithoutProperties(_ref2, ["className", "trustPoints"]);

  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement(_EmblemFrame.default, {
    icon: _icons.Bestseller
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1
  }, trustPoints.map(function (pointText) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      key: pointText,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(Row, null, pointText));
  }))));
};

exports.TrustBox = TrustBox;
TrustBox.propTypes = {
  trustPoints: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
};
var _default = TrustBox;
exports.default = _default;